/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VwbPodDescription
 */
export interface VwbPodDescription {
    /**
     * 
     * @type {string}
     * @memberof VwbPodDescription
     */
    podId?: string;
    /**
     * 
     * @type {string}
     * @memberof VwbPodDescription
     */
    userFacingId?: string;
    /**
     * 
     * @type {string}
     * @memberof VwbPodDescription
     */
    description?: string;
}

/**
 * Check if a given object implements the VwbPodDescription interface.
 */
export function instanceOfVwbPodDescription(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VwbPodDescriptionFromJSON(json: any): VwbPodDescription {
    return VwbPodDescriptionFromJSONTyped(json, false);
}

export function VwbPodDescriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbPodDescription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'podId': !exists(json, 'podId') ? undefined : json['podId'],
        'userFacingId': !exists(json, 'userFacingId') ? undefined : json['userFacingId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function VwbPodDescriptionToJSON(value?: VwbPodDescription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'podId': value.podId,
        'userFacingId': value.userFacingId,
        'description': value.description,
    };
}

